module.exports = __webpack_public_path__ + "static/media/Curam_Logo.d6ea9fad.png";